module.exports = __webpack_public_path__ + "img/test.f3fc82d4.png";